var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isShow)?_c('div',{staticClass:"v-popover"},[_c('div',{staticClass:"popover-content"},[_c('span',{staticClass:"title-span"},[_vm._v(_vm._s(_vm.title))])]),_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content-down"},[_c('img',{attrs:{"src":require("@/assets/images/down.png"),"alt":""}})])
}]

export { render, staticRenderFns }